/**
 * @fileoverview Setu Components - Main Entry Point
 * Modern React component library built on shadcn/ui with Fictoan compatibility
 */

// Components
export * from "./components";

// Utilities
export * from "./lib/utils";

// Version and metadata
export const LIBRARY_VERSION = "0.1.0";
export const LIBRARY_NAME = "@setu/components";
